/**
 * Hybrid List Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps) or the component was extended with styled()
 * (isStyledExtension). Otherwise renders the Tailwind path (preferred — no
 * runtime CSS-in-JS).
 */
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeListProps } from "./ListTypes";
import ListStyled from "./ListStyled";
import ListTailwind from "./ListTailwind";

const ListHybrid = (props: TypeListProps) => {
  if (hasStyledProps(props) || isStyledExtension(props)) {
    return <ListStyled {...props} />;
  }

  return <ListTailwind {...props} />;
};

ListHybrid.displayName = "List";

export default ListHybrid;
